<div class="header">
  <div id="header-wrapper">
    <h2>Mes trackers personnalisés</h2>
    <div class="d-inline-flex">
      <button id="new-custom-tracker-button" type="button" class="btn btn-outline-primary btn-outline text-icon"
              (click)="showTrackersCreationModal()">
        Nouveau tracker
        <i i-bs name="plus-square" width="15" height="15"></i>
      </button>
    </div>
  </div>
  <msd-segmented-navigation #tabs [items]="segmentedItems"></msd-segmented-navigation>
</div>
<hr />
<div id="content-wrapper">
  <router-outlet></router-outlet>
</div>
